<div class="wrapper mt-2">
    <div class="table2 " >                                           
      <div class="row2">
      
        <div class="cell2 text-right" style="box-shadow: none;">
            <h4><u>All Scales </u> </h4>
        </div>
        <div class="cell2 text-lg-right" style="box-shadow:none;border-radius:12px">
          <button (click)="addNewScale()" style="background-color: #4A9F37;border-radius: 8px;color: white;" class="btn mb-1"><i class="fas fa-plus"></i> Add Scale</button>
        </div>

      </div>
    </div> 

    <div class="table shadow p-3 mb-5" *ngIf="allOptionScales.length!=0">
      
      <div class="row header" >
        
        <div class="cell">
          S.No
        </div>
        <div class="cell">
          Q-Response Type
        </div> 
        <div class="cell">
          Total Options
        </div> 
        <div class="cell">
          Reverse
        </div>
        <div class="cell">
          Created On
        </div>
        <div class="cell">
          
        </div>
        <div class="cell">
          
        </div>
        <div class="cell">
          
        </div>
      </div>
      
      <div class="row" *ngFor="let opScale of allOptionScales | paginate :{itemsPerPage:8,currentPage:p};let i = index;">
      
        <div class="cell" data-title="S.No.">
            {{i+1}}
        </div>
        <div class="cell" data-title="Q-Response Type">
            {{ opScale.title }}
        </div>
        <div class="cell" data-title="Total Options">
            {{ opScale.options.length }}
        </div>
        <div class="cell" data-title="Reverse">
          {{ opScale.reverse==undefined?'False':opScale.reverse.toString() | titlecase }}
      </div>
        <div class="cell" data-title="Created On">
            {{ opScale.createdAt | date:'medium' }}
        </div>
        <div class="cell" (click)="viewScale(opScale)">
          <i class="fas fa-external-link-alt" aria-hidden="true" style="font-size: 17px;color:rgb(16, 107, 243);cursor: pointer;"></i>
        </div>     
        <div class="cell" (click)="editScale(opScale)">
          <i class="fas fa-pen" aria-hidden="true" style="font-size: 17px;color:darkgreen;cursor: pointer;"></i>
        </div>       
        <div class="cell" style="cursor:pointer;">
            <i class="fas fa-trash" aria-hidden="true" style="font-size: 17px;color:rgb(192, 31, 31);cursor: pointer;"></i>
       </div>
             
      </div>          
    </div>

    <div class="text-center mt-5" style="margin-left: -100px;" *ngIf="allOptionScales.length==0">
      <h5 style="color: darkblue;">**No Option Scale Exists**</h5>
    </div>
    <!-- pagination -->
    <pagination-controls (pageChange)="p=$event" *ngIf="allOptionScales.length!=0"></pagination-controls>
 </div> 

  
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Please wait...</p>
</ngx-spinner>
